import { SEO_ENABLED, VARIANT } from "../../config"

export const isSeoEnabled = () => {
    return VARIANT === "SPLUS" && SEO_ENABLED === "true";
}